import { API_BASE_URL } from '../../../lib/api';

import { apiFetch } from '@/lib/apiFetch';
import { withTenant } from '../../../lib/tenantHeaders';

/**
 * Los headers se construyen DENTRO de cada función a propósito.
 * `withTenant()` lee el token y el slug de localStorage: si se
 * calcula una sola vez al importar el módulo, quedan congelados y
 * un re-login sin recargar la página deja headers obsoletos.
 */
const jsonHeaders = () => withTenant({ 'Content-Type': 'application/json' });

export const fetchSeaports = async ({ limit = 10, offset = 1, query = {}, sort } = {}) => {
  const res = await apiFetch(`${API_BASE_URL}/seaports/filter`, {
    method: 'POST',
    headers: jsonHeaders(),
    body: JSON.stringify({ limit, offset, query, sort }),
  });
  return res.json();
};

export const createSeaport = async (data) => {
  const res = await apiFetch(`${API_BASE_URL}/seaports`, {
    method: 'POST',
    headers: jsonHeaders(),
    body: JSON.stringify(data),
  });
  return res.json();
};

export const updateSeaport = async (id, data) => {
  const res = await apiFetch(`${API_BASE_URL}/seaports/${id}`, {
    method: 'PUT',
    headers: jsonHeaders(),
    body: JSON.stringify(data),
  });
  return res.json();
};

export const deleteSeaport = async (id) => {
  const res = await apiFetch(`${API_BASE_URL}/seaports/${id}`, {
    method: 'DELETE',
    headers: withTenant(),
  });
  return res.json();
};

export const toggleSeaportStatus = async (id) => {
  const res = await apiFetch(`${API_BASE_URL}/seaports/${id}/toggle-status`, {
    method: 'POST',
    headers: jsonHeaders(),
  });
  return res.json();
};

export const importSeaports = async (rows) => {
  const res = await apiFetch(`${API_BASE_URL}/seaports/import`, {
    method: 'POST',
    headers: jsonHeaders(),
    body: JSON.stringify({ rows }),
  });
  return res.json();
};

export const exportSeaports = async ({ query = {}, sort } = {}) => {
  return fetchSeaports({ limit: 10000, offset: 1, query, sort });
};
